// extracted by mini-css-extract-plugin
export default {"TouchInput":"touchInput_TouchInput__9O0SS","Wrapper":"touchInput_Wrapper__6o-W2"};